import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { resolveBadge, type BadgeOptions, type DocumentItem } from '@document-explorer/core';

/**
 * One badge cell: a status, a state, a category.
 *
 * What tone a value carries is decided by `resolveBadge()` in
 * `@document-explorer/core`, so a status looks the same here as in React.
 */
@Component({
  selector: 'de-badge-cell',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    @if (badge(); as resolved) {
      <span
        class="de-badge"
        [class]="'de-badge de-badge--' + resolved.tone"
        [class.de-badge--pill]="resolved.variant === 'pill'"
        [attr.title]="resolved.label"
      >
        {{ resolved.label }}
      </span>
    }
  `,
})
export class DeBadgeCellComponent {
  readonly item = input.required<DocumentItem>();
  /** The column key, used as the default value source. */
  readonly columnKey = input<string>('');
  readonly options = input<BadgeOptions>({});

  protected readonly badge = computed(() => resolveBadge(this.item(), this.columnKey(), this.options()));
}
